/**
 * cartDrawer — Componente thin per il drawer carrello.
 *
 * Lo stato vive in Alpine.store('cart'). Questo componente gestisce
 * solo comportamento UI locale (es. conferma rimozione).
 *
 * Uso nel template:
 *   <div x-data="cartDrawer">
 */
export function registerCartDrawer(Alpine) {
    Alpine.data('cartDrawer', () => ({
        // Nessuno stato locale: tutto da $store.cart
    }));
}
